<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="'REPORT_THANK_YOU.BREADCRUMB_NAME' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="thank-you">
    <div class="thank-you__content">
      <div class="thank-you__content__emoji">🎉🎉🎉</div>
      <div class="thank-you__content__title" [innerHTML]="'REPORT_THANK_YOU.TITLE' | translate"></div>
      <app-report-kpi
        class="thank-you__content__report-kpi"
        [actionButton]="actionButton$ | async"
        [report]="report$ | async"
      ></app-report-kpi>
      <div
        class="thank-you__content__description"
        [innerHTML]="'REPORT_THANK_YOU.DESCRIPTION' | translate:{ report: ((report$ | async)?.dataDefinitionId | toDataDefinition | async)?.description }"
      ></div>
    </div>

    <div class="thank-you__footer">
      <ion-button
        class="thank-you__footer__button button --primary"
        [innerHTML]="'REPORT_THANK_YOU.SEE_REPORT' | translate"
        (click)="seeReport()"
      ></ion-button>
      <ion-button
        class="thank-you__footer__button button --text --dark"
        [innerHTML]="'REPORT_THANK_YOU.DISMISS' | translate"
        (click)="goBack()"
      ></ion-button>
    </div>
  </div>
</ion-content>
